import { useQuery } from '@tanstack/react-query';
import * as api from '../api/mail.api';

export const useThread = (messageId) => {
  const key = ['mail','thread', messageId];
  return useQuery({ queryKey: key, queryFn: () => api.fetchThread(messageId), enabled: !!messageId });
};
